/**!*******************************************************************
 *
 * Copyright (c) Epic AI GmbH. All rights reserved.
 * Author:  Alexander Claas
 * 
 ********************************************************************!*/

 import { store } from "@/store";
 import { BotStore } from "@/store/constants";
 import { fetchCloudRun } from "../Helper";
 
 export const publishVersion = async (name: string, description?: string) => {
   const chatbotId = store.getters[BotStore.Getters.GET_ID];
   await fetchCloudRun("https://app.chatcaptain.com/api/bot/chatbots/" + chatbotId + "/versions", "POST", {}, {
     name,
     description: description || ""
   });
 }